import { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useTranslate } from 'i18n-calypso';
import { getQueryArgs } from '@wordpress/url';
import { addSeconds } from 'date-fns';
import { TZDate } from "@date-fns/tz";

import Spinner from 'components/spinner';
import useOauth from 'data/oauth/use-oauth';
import getAuthHashParams from 'lib/utils/get-auth-hash-params';
import OverviewSidebar from 'sections/overview/sidebar';
import Layout from 'components/layout';
import Content from 'components/content';

export default function Auth() {
	const navigate = useNavigate();
	const translate = useTranslate();
	const { saveOauth } = useOauth();
	const params = getAuthHashParams();
	const [ error, setError ] = useState( { code: '', description: '' } );

	useEffect( () => {
		const accessToken = params?.access_token?.toString() || '';
		const expiresIn = parseInt( params?.expires_in?.toString() || '0' ) || 0;

		saveOauth( {
			accessToken: accessToken,
			expiresIn: expiresIn,
			expiresAt: addSeconds( new TZDate( new Date() ), expiresIn ),
			tokenType: params?.token_type?.toString() || '',
			siteId: parseInt( params?.site_id?.toString() || '0' ),
			scope: params?.scope?.toString() || '',
		} );

		const errorCode = params?.error?.toString() || 'unknown';

		if ( ! accessToken && errorCode !== error.code ) {
			setError(
				{
					code: errorCode,
					description: params?.error_description?.toString() || translate( 'An unknown error occurred.' ),
				},
			);
		}

		if ( accessToken ) {
			const redirect = getQueryArgs( location.search )?.return?.toString() || '';
			const redirectUrl = new URL( redirect, document.baseURI );

			if ( new URL( document.baseURI ).origin === redirectUrl.origin ) {
				navigate( redirectUrl.pathname + redirectUrl.search + redirectUrl.hash, { replace: true } );
			} else {
				navigate( '/', { replace: true } );
			}
		}
	}, [] );

	return (
		<Layout Sidebar={ OverviewSidebar }>
			<Content className="flex justify-center items-center">
				{ ! error.code && (
					<Spinner big />
				) }

				{ error.code && (
					<div className="text-center">
						<h2 className="mb-2 text-xl font-bold">
							{ translate( 'Uh oh. Something went wrong.' ) }
							&nbsp;
							<Link to="/auth">{ translate( 'Try again?' ) }</Link>
						</h2>

						<p>[{ error.code }] { error.description }</p>
					</div>
				) }
			</Content>
		</Layout>
	);
}
